<template>
  <md-dialog :md-active.sync="showDialog" class="mkt-ops -main-font pricinglist dialog-sync-cipher"
    :md-click-outside-to-close="false" :md-close-on-esc="false">
    <md-dialog-title>
      <div class="md-layout">
        <div class="md-layout-item md-size-90">
          <div class="-font-kanit -title">Sync ข้อมูลราคา/ต้นทุน</div>
          <div class="-font-kanit -subtitle">
            ระบบจะ sync ไปยัง Cipher ก่อน แล้วจึง sync ต่อไปยัง SalesOps โดยอัตโนมัติ
          </div>
        </div>
        <div class="md-layout-item md-size-10 -close" @click="onClose">
          <md-icon>close</md-icon>
        </div>
      </div>
    </md-dialog-title>

    <div class="md-layout dialog-content">
      <div class="md-layout-item md-size-100 -banner-error" v-if="bannerError">
        <md-icon>error_outline</md-icon>
        <div>
          <div class="-banner-title">Sync Failed</div>
          <div class="-banner-desc -font-kanit">{{ bannerError }}</div>
        </div>
      </div>

      <div class="md-layout-item md-size-100 -steps">
        <div class="-step" :class="'-' + step.status" v-for="(step, stepIndex) in steps" :key="step.key">
          <span class="-connector" v-if="stepIndex < steps.length - 1"
            :class="{ '-active': steps[stepIndex].status == 'done' }"></span>

          <div class="-marker">
            <div class="-marker-content">
              <svg v-if="step.status == 'done'" class="-marker-svg" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M6 12.5 L10 16.5 L18 7.5" fill="none" stroke="#fff" stroke-width="2.5"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <svg v-else-if="step.status == 'error'" class="-marker-svg" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M7 7 L17 17 M17 7 L7 17" fill="none" stroke="#fff" stroke-width="2.5"
                  stroke-linecap="round" />
              </svg>
              <span v-else-if="step.status == 'running'" class="-marker-spinner"></span>
              <span v-else class="-marker-num">{{ stepIndex + 1 }}</span>
            </div>
          </div>

          <div class="-detail">
            <div class="-label">{{ step.label }}</div>
            <div class="-time -failed" v-if="step.status == 'error'">Failed ({{ step.failedAt }})</div>
            <div class="-time -running" v-else-if="step.status == 'running'">Syncing...</div>
            <div class="-time -done" v-else-if="step.status == 'done'">Last synced: {{ step.lastSynced }}</div>
            <div class="-time" v-else>Last synced: {{ step.lastSynced || "-" }}</div>
          </div>
        </div>
      </div>
    </div>

    <md-dialog-actions class="-action">
      <template v-if="hasError">
        <md-button class="md-primary -cancel" :disabled="syncing" @click="onClose">
          <b>CLOSE</b>
        </md-button>
        <md-button class="md-primary -retry" :disabled="syncing" @click="startSync">
          <b>RETRY SYNC</b>
        </md-button>
      </template>
      <md-button v-else class="md-primary -confirm" :disabled="syncing" @click="startSync">
        <b>{{ buttonLabel }}</b>
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import moment from "moment-timezone";
import SyncService from "@/services/sync";

const STORAGE_KEY = "pricing-sync-last-synced";

export default {
  name: "dialog-sync-cipher",

  props: {
    show: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      showDialog: false,
      syncing: false,
      runningStep: -1,
      bannerError: "",
      steps: [
        {
          key: "cipher",
          label: "Sync to Cipher",
          status: "pending",
          lastSynced: "",
          failedAt: ""
        },
        {
          key: "salesops",
          label: "Sync to SalesOps",
          status: "pending",
          lastSynced: "",
          failedAt: ""
        }
      ]
    };
  },

  computed: {
    hasError() {
      return this.steps.some(step => step.status == "error");
    },
    buttonLabel() {
      if (!this.syncing) {
        return "SYNC TO CIPHER \u2192 SALESOPS";
      }
      return this.runningStep == 0
        ? "SYNCING TO CIPHER..."
        : "SYNCING TO SALESOPS...";
    }
  },

  watch: {
    show(val) {
      if (val) {
        this.openDialog();
      } else {
        this.showDialog = false;
      }
    },
    showDialog(val) {
      if (!val) {
        this.$emit("close");
      }
    }
  },

  created() {
    this.loadLastSynced();
  },

  methods: {
    openDialog() {
      if (!this.syncing) {
        this.resetSteps();
        this.loadLastSynced();
      }
      this.showDialog = true;
    },
    resetSteps() {
      this.bannerError = "";
      this.runningStep = -1;
      this.syncing = false;
      this.steps.forEach(step => {
        step.status = "pending";
        step.failedAt = "";
      });
    },
    async startSync() {
      if (this.syncing) return false;

      this.resetSteps();
      this.syncing = true;

      try {
        await this.runStep(0, SyncService.syncPricesToCipher);
        await this.runStep(1, SyncService.syncPricesToSalesOps);
        this.$emit("success");
      } catch (error) {
        //error stop here
      } finally {
        this.syncing = false;
        this.runningStep = -1;
      }
    },
    async runStep(index, request) {
      let step = this.steps[index];

      this.runningStep = index;
      step.status = "running";

      try {
        await request();
        step.status = "done";
        step.lastSynced = moment().format("HH:mm");
        this.saveLastSynced();
      } catch (error) {
        step.status = "error";
        step.failedAt = moment().format("HH:mm");
        this.bannerError =
          index == 0
            ? "เกิดข้อผิดพลาดในการส่งข้อมูลไปยังระบบ Cipher กรุณาตรวจสอบและลองใหม่อีกครั้ง"
            : "เกิดข้อผิดพลาดในการส่งข้อมูลไปยังระบบ SalesOps กรุณาตรวจสอบและลองใหม่อีกครั้ง";
        throw error;
      }
    },
    loadLastSynced() {
      try {
        let saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
        this.steps.forEach(step => {
          if (typeof saved[step.key] == "string") {
            step.lastSynced = saved[step.key];
          }
        });
      } catch (error) {
        localStorage.removeItem(STORAGE_KEY);
      }
    },
    saveLastSynced() {
      let saved = {};
      this.steps.forEach(step => {
        saved[step.key] = step.lastSynced;
      });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
    },
    onClose() {
      this.showDialog = false;
    }
  }
};
</script>

<style lang="scss">
.pricinglist.dialog-sync-cipher {
  font-family: lato;
  width: 340px !important;
  max-width: 90%;
  min-width: unset;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;

  &.md-dialog {
    max-height: unset;
  }

  .md-dialog-title.md-title {
    margin-bottom: 5px;

    .-title {
      font-size: 17px;
      font-weight: 600;
      color: #414141;
    }

    .-subtitle {
      font-size: 12px !important;
      line-height: 1.5;
      color: #949496;
      margin-top: 5px;
    }

    .-close {
      text-align: right;
      cursor: pointer;
    }
  }

  .dialog-content {
    padding: 5px 22px 15px 22px;

    .-banner-error {
      display: flex;
      align-items: flex-start;
      padding: 10px 12px;
      margin-bottom: 15px;
      border-radius: 4px;
      border: 1px solid #f5c6cb;
      background: #fdecea;
      color: #f44336;
      font-size: 12px;
      line-height: 1.4;

      .md-icon {
        font-size: 16px !important;
        min-width: 16px;
        width: 16px;
        height: 16px;
        margin-right: 8px;
        margin-top: 2px;
        color: #f44336;
      }

      .-banner-title {
        font-weight: bold;
        color: #c62828;
        margin-bottom: 2px;
      }

      .-banner-desc {
        font-size: 11px;
        color: #f44336;
        line-height: 1.5;
      }
    }

    .-steps {
      padding: 5px 0;
    }

    .-step {
      position: relative;
      display: flex;
      align-items: flex-start;
      padding-bottom: 18px;

      &:last-child {
        padding-bottom: 0;
      }

      &.-done .-marker {
        background: #4caf50;
        border-color: #4caf50;
      }

      &.-running .-marker {
        border-color: #4caf50;
      }

      &.-error .-marker {
        background: #f44336;
        border-color: #f44336;
      }
    }

    .-connector {
      position: absolute;
      top: 32px;
      left: 16px;
      width: 2px;
      height: calc(100% - 32px);
      margin-left: -1px;
      background: #e0e0e0;
      z-index: 0;

      &.-active {
        background: #4caf50;
      }
    }

    .-marker {
      position: relative;
      z-index: 1;
      flex: 0 0 32px;
      width: 32px;
      height: 32px;
      box-sizing: border-box;
      border: 1px solid #e0e0e0;
      border-radius: 50%;
      background: #fff;
      color: #a8a8a8;

      .-marker-content {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .-marker-num {
        font-size: 12px;
        font-weight: bold;
        line-height: 1;
      }

      .-marker-svg {
        display: block;
        width: 14px;
        height: 14px;
        margin: 0;
        padding: 0;
      }

      .-marker-spinner {
        display: block;
        width: 14px;
        height: 14px;
        margin: 0;
        border: 2px solid #e0e0e0;
        border-top-color: #4caf50;
        border-radius: 50%;
        animation: sync-marker-spin 0.8s linear infinite;
      }
    }

    .-detail {
      padding-left: 12px;
      padding-top: 2px;

      .-label {
        font-size: 13px;
        font-weight: bold;
        color: #414141;
      }

      .-time {
        font-size: 11px;
        color: #a8a8a8;
        margin-top: 2px;

        &.-running {
          color: #3f51b5;
        }

        &.-failed {
          color: #f44336;
          font-weight: bold;
        }

        &.-done {
          color: #4caf50;
        }
      }
    }
  }

  .-action {
    padding: 5px 25px 15px 25px;

    .-cancel {
      color: #727272;
    }

    .-confirm {
      color: #fff;
      background-color: #4caf50 !important;
      width: 100%;
      margin: 0;
      height: 38px;
    }

    .-retry {
      color: #fff;
      background-color: #f44336 !important;
      height: 38px;
    }

    .md-button[disabled] {
      opacity: 0.6;
    }
  }
}

@keyframes sync-marker-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
